import React, { useState, useEffect } from "react";
import { useTranslate } from "../../context/TranslateContext";

/**
 * Translate component - wraps text and auto-translates based on current language
 * 
 * Usage:
 * <T>Hello World</T>
 * <T as="h1">Welcome to my portfolio</T>
 */
const T = ({ children, as: Component = "span", className = "", ...props }) => {
  const { currentLang, translateText, isEnglish } = useTranslate();
  const [translatedText, setTranslatedText] = useState(children);

  useEffect(() => {
    // Skip if English or not a string
    if (isEnglish) {
      setTranslatedText(children);
      return;
    }
    
    if (typeof children !== "string") {
      setTranslatedText(children);
      return;
    }

    // Translate
    translateText(children, currentLang)
      .then((result) => {
        setTranslatedText(result);
      })
      .catch(() => {
        setTranslatedText(children);
      });
      
  }, [children, currentLang, isEnglish]);

  return (
    <Component className={className} {...props}>
      {translatedText}
    </Component>
  );
};

export default T;